var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallethistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAEEFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4993 17.9648C27.4993 16.7174 26.4946 15.6938 25.2147 15.5897L24.6847 14.1128C24.2239 12.8289 22.7337 12.1702 21.4084 12.6647L13.4458 15.6356C13.3662 15.6652 13.2942 15.7053 13.2306 15.7534C12.3133 16.1066 11.666 16.9636 11.666 17.9648V25.1162C11.666 26.4327 12.7853 27.5 14.166 27.5L24.9993 27.5C26.3801 27.5 27.4993 26.4327 27.4993 25.1162V23.3144C27.9975 23.0396 28.3327 22.526 28.3327 21.9378V20.3486C28.3327 19.7604 27.9975 19.2468 27.4993 18.972V17.9648ZM25.8327 18.7594V17.9648C25.8327 17.5259 25.4596 17.1702 24.9993 17.1702L14.166 17.1702C13.7058 17.1702 13.3327 17.5259 13.3327 17.9648L13.3327 25.1162C13.3327 25.555 13.7058 25.9108 14.166 25.9108L24.9993 25.9108C25.4596 25.9108 25.8327 25.555 25.8327 25.1162V23.527H24.9993C23.6186 23.527 22.4993 22.4597 22.4993 21.1432C22.4993 19.8266 23.6186 18.7594 24.9993 18.7594H25.8327ZM23.1078 14.6273L23.45 15.581L18.1659 15.581L22.0157 14.1446C22.4574 13.9798 22.9542 14.1993 23.1078 14.6273ZM24.166 21.1432C24.166 20.7043 24.5391 20.3486 24.9993 20.3486H26.666V21.9378H24.9993C24.5391 21.9378 24.166 21.582 24.166 21.1432Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallethistory);
export default __webpack_public_path__ + "static/media/wallethistory.4800e7249fc973477f910ca0714e36ec.svg";
export { ForwardRef as ReactComponent };